import React from 'react';
import { Col, Row } from 'reactstrap';

import history from '../../../utils/history';
import { Desktop, Mobile } from '../../Common/const';
import ModalBase from '../../ModalBase/ModalBase';
import PracticeExamExpirationNotice from './PracticeExamExpirationNotice';

const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
const WEEK_IN_MILLISECONDS = 7 * DAY_IN_MILLISECONDS;

class Cycle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      availableExam: true,
      openRegenerateModal: false,
      openSettingsChangedModal: false,
    };
  }

  customExamRowRef = (node) => {
    if (node && this.props.fromPSView) {
      node.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.practiceExamFlag.type !== 'running') {
      this.setState({
        availableExam: nextProps.practiceExamFlag.type === 'available',
      });
    }
  }

  handleLaunchClick = (item) => {
    this.props.setReviewMode(false);
    if (this.props.user) {
      if (!this.props.user.active) {
        this.props.openCancelPopUp(true);
      } else {
        window.localStorage.setItem('isCustomPracticeExamChosen', 'false');
        history.push({
          pathname: '/app/practice-exam',
          state: {
            practiceExamId: item.practiceExamId,
            examTimeInMillis: item.examTimeInMillis,
            amountQuestions: item.amountQuestions,
          },
        });
      }
    }
  };

  handleLaunchCustomClick = (practiceExamId) => {
    this.props.setReviewMode(false);
    if (this.props.user) {
      if (!this.props.user.active) {
        this.props.openCancelPopUp(true);
      } else {
        window.localStorage.setItem('isCustomPracticeExamChosen', 'true');
        history.push({
          pathname: '/app/practice-exam',
          state: { practiceExamId, isCustom: true },
        });
      }
    }
  };

  handleRegenerate = () => {
    this.props.regenerateCustomPE();
    this.setState({ openRegenerateModal: false });
  };

  handleRetakeClick = (userPracticeExamId) => {
    this.props.setReviewMode(false);

    if (this.props.user && !this.props.user.active) {
      this.props.openCancelPopUp(true);
      return;
    }

    if (
      this.props.practiceExamFlag.type !== 'running' &&
      !this.props.reviewMode
    ) {
      this.props.setRetakeMode(true);
      this.props.startPracticeExam(userPracticeExamId);
    }
    window.localStorage.setItem('isCustomPracticeExamChosen', 'false');
    history.push('/app/practice-exam');
  };

  reviewClick = (userPracticeExamId, retake, isCustom = false) => {
    this.props.practiceExamResults(userPracticeExamId, retake, isCustom);
    this.props.setReviewMode(true);
    history.push('/app/practiceExamResults');
  };

  render() {
    const {
      checkPracticeExamLoading,
      retakeMode,
      practiceExamFlag,
      practiceExamRunning,
      reviewMode,
      selectOption,
      customPracticeExamStatus,
      customPracticeExamHistory,
      customPracticeExamLoading,
      isCurrentTabSKT,
    } = this.props;
    const showWeeklyExams = this.props.section !== 'custom';
    const showCustomExam = this.props.section !== 'weekly';
    const exams = this.props.exams.map((item, index) => {
      const showExpiration =
        this.props.section === 'weekly' &&
        item.availableFrom &&
        this.props.nextWeeklyGenerationAt;
      const weeksUntilExpiration = this.props.exams.length - 1 - index;
      const expirationTimestamp =
        this.props.nextWeeklyGenerationAt +
        weeksUntilExpiration * WEEK_IN_MILLISECONDS;
      const isNextWeeklyExpiration = weeksUntilExpiration === 0;
      const showExpirationWarning =
        showExpiration &&
        expirationTimestamp - Date.now() <= DAY_IN_MILLISECONDS;
      const expirationWarning = showExpirationWarning ? (
        <span className="practice-exam-expiration-warning">Expiring soon</span>
      ) : null;
      const expirationNotice = showExpiration ? (
        <PracticeExamExpirationNotice
          nextWeeklyGenerationAt={expirationTimestamp}
          weeklyPracticeExamBuildInProgress={
            isNextWeeklyExpiration &&
            this.props.weeklyPracticeExamBuildInProgress
          }
        />
      ) : null;

      return (
        <div key={`${item}-${index}`}>
          <Row className="history-row">
            <Col xs={9} md={5} className="d-flex pr-0 exam-title-cell">
              <div className="pe-title-group">
                <p className="mb-0 pe-title">{item.name}</p>
                {showExpiration &&
                  (this.props.expirationWarningNextToAction ? (
                    expirationNotice
                  ) : (
                    <div className="pe-expiration-details">
                      {expirationNotice}
                      {expirationWarning}
                    </div>
                  ))}
              </div>
              {!item.resolved ? (
                <button
                  className="btn btn-outline-secondary rounded-lg my-auto pe-btn"
                  onClick={() => {
                    this.handleLaunchClick(item);
                  }}
                  disabled={
                    checkPracticeExamLoading ||
                    retakeMode ||
                    practiceExamFlag.type === 'not-developed' ||
                    (!item.inProgress && !item.enableLaunch) ||
                    (!reviewMode &&
                      practiceExamRunning?.id &&
                      practiceExamRunning.practiceExam !==
                        item.practiceExamId &&
                      practiceExamRunning.id !== item.id)
                  }
                >
                  {(!reviewMode && item.inProgress) ||
                  (!retakeMode &&
                    practiceExamRunning?.id &&
                    (practiceExamRunning.practiceExam === item.practiceExamId ||
                      practiceExamRunning?.id === item.id)) ? (
                    <span className="font-italic"> In progress </span>
                  ) : (
                    'LAUNCH'
                  )}
                </button>
              ) : (
                <button
                  className="btn btn-outline-secondary rounded-lg my-auto pe-btn"
                  onClick={() => this.handleRetakeClick(item.id)}
                  disabled={
                    checkPracticeExamLoading ||
                    !item.enableRetake ||
                    (practiceExamRunning?.id &&
                      practiceExamRunning.id !== item.id)
                  }
                  data-test="retake-exam-button"
                >
                  {!reviewMode && practiceExamRunning?.id === item.id ? (
                    <span className="font-italic"> In progress </span>
                  ) : (
                    <span>RE-TAKE</span>
                  )}
                </button>
              )}
              {this.props.expirationWarningNextToAction && expirationWarning}
            </Col>

            <Col xs={3} md={6} className="p-0 d-flex">
              {/* in Desktop render all column */}
              <Desktop>
                <Col xs={3} className="text-center p-0">
                  {item.resolved && item.total && !item.inProgress ? (
                    <div title="Practice exam result">
                      <a
                        onClick={() => this.reviewClick(item.id, false)}
                        className="linkResult"
                      >{`${item.myScore}/${item.total}`}</a>
                    </div>
                  ) : (
                    <p>-</p>
                  )}
                </Col>
                <Col xs={3} className="text-center p-0">
                  {item.resolved && item.total && !item.inProgress ? (
                    <div title="Retake exam result">
                      <a
                        onClick={() => this.reviewClick(item.id, true)}
                        className="linkResult"
                      >{`${
                        item.lastScore !== null ? item.lastScore : item.myScore
                      }/${item.total}`}</a>
                    </div>
                  ) : (
                    <p>-</p>
                  )}
                </Col>
                <Col xs={3} className="text-center p-0">
                  {item.resolved && item.total && !item.inProgress ? (
                    <p className="my-auto">{`${item.average}/${item.total}`}</p>
                  ) : (
                    <p>-</p>
                  )}
                </Col>
                <Col xs={3} className="text-center p-0">
                  {item.resolved && !item.inProgress ? (
                    <p className="my-auto">{`${item.pts}pts`}</p>
                  ) : (
                    <p className="my-auto">-</p>
                  )}
                </Col>
              </Desktop>

              {/* in mobile just render de select column */}
              <Mobile>
                {selectOption === 'FIRST SCORE' && (
                  <Col xs={12} className="text-right ">
                    {item.resolved && item.total && !item.inProgress ? (
                      <div>
                        <a
                          onClick={() => this.reviewClick(item.id, false)}
                          className="linkResult"
                        >{`${item.myScore}/${item.total}`}</a>
                      </div>
                    ) : (
                      <p>-</p>
                    )}
                  </Col>
                )}
                {selectOption === 'LAST SCORE' && (
                  <Col xs={12} className="text-right ">
                    {item.resolved && item.total && !item.inProgress ? (
                      <div>
                        <a
                          onClick={() => this.reviewClick(item.id, true)}
                          className="linkResult"
                        >
                          {[
                            item.lastScore !== null
                              ? item.lastScore
                              : item.myScore,
                            item.total,
                          ].join('/')}
                        </a>
                      </div>
                    ) : (
                      <p>-</p>
                    )}
                  </Col>
                )}
                {selectOption === 'myLastScore' && (
                  <Col xs={12} className="text-right">
                    {item.resolved && item.total && !item.inProgress ? (
                      <p className="my-auto">-</p>
                    ) : (
                      <p>-</p>
                    )}
                  </Col>
                )}
                {selectOption === 'AVERAGE' && (
                  <Col xs={12} className="text-right">
                    {item.resolved && item.total && !item.inProgress ? (
                      <p className="my-auto">{`${item.average}/${item.total}`}</p>
                    ) : (
                      <p>-</p>
                    )}
                  </Col>
                )}
                {selectOption === 'POINTS' && (
                  <Col xs={12} className="text-right">
                    {item.resolved && !item.inProgress ? (
                      <p className="my-auto">{`${item.pts}pts`}</p>
                    ) : (
                      <p className="my-auto">-</p>
                    )}
                  </Col>
                )}
              </Mobile>
            </Col>
          </Row>
          {index < this.props.exams.length - 1 && <hr />}
        </div>
      );
    });
    return (
      <div className={showWeeklyExams ? 'mb-5' : 'mb-0'}>
        <Desktop>
          <Row>
            <Col xs={6} className="offset-5 d-flex p-0 history-header">
              <Col xs={3} className="text-center p-0">
                <p>FIRST SCORE</p>
              </Col>
              <Col xs={3} className="text-center p-0">
                <p>LAST SCORE</p>
              </Col>
              <Col xs={3} className="text-center p-0">
                <p>AVERAGE</p>
              </Col>
              <Col xs={3} className="text-center p-0">
                <p>EARNED</p>
              </Col>
            </Col>
          </Row>
        </Desktop>
        {showWeeklyExams && exams}
        {/* BEGIN CUSTOM PRACTICE EXAM ROW 
        this row will ONLY appear if a custom exam was previously generated and user is in SKT side (not available for PFE) */}
        {showCustomExam &&
          isCurrentTabSKT &&
          customPracticeExamStatus &&
          !customPracticeExamStatus.notGenerated && (
            <>
              <Row
                innerRef={this.customExamRowRef}
                className={`history-row${this.props.fromPSView ? ' history-row--highlighted' : ''}`}
              >
                <Col xs={9} md={5} className="d-flex pr-0 exam-title-cell">
                  <div className="pe-title-group">
                    <p className="my-auto pe-title">Custom Practice Exam</p>
                  </div>
                  {!customPracticeExamHistory?.resolved ? (
                    <button
                      className="btn btn-outline-secondary rounded-lg my-auto pe-btn"
                      onClick={() =>
                        this.handleLaunchCustomClick(
                          customPracticeExamStatus?.availablePracticeExam?.id,
                        )
                      }
                      disabled={
                        practiceExamRunning?.id &&
                        !practiceExamRunning.isCustom &&
                        !customPracticeExamHistory?.inProgress
                      }
                    >
                      {customPracticeExamHistory?.inProgress
                        ? 'In progress'
                        : 'LAUNCH'}
                    </button>
                  ) : (
                    <button
                      className="btn btn-outline-secondary rounded-lg my-auto pe-btn"
                      onClick={() =>
                        customPracticeExamStatus?.questionSettingChanged
                          ? this.setState({ openSettingsChangedModal: true })
                          : this.setState({ openRegenerateModal: true })
                      }
                      disabled={
                        customPracticeExamLoading ||
                        customPracticeExamStatus?.has24HoursPassed === false
                      }
                    >
                      {customPracticeExamLoading
                        ? 'Generating...'
                        : 'REGENERATE'}
                    </button>
                  )}
                </Col>
                <Col xs={3} md={6} className="p-0 d-flex">
                  <Desktop>
                    <Col xs={3} className="text-center p-0">
                      {customPracticeExamHistory?.resolved &&
                      customPracticeExamHistory?.total ? (
                        <a
                          onClick={() =>
                            this.reviewClick(
                              customPracticeExamHistory.id,
                              false,
                              true,
                            )
                          }
                          className="linkResult"
                        >
                          {`${customPracticeExamHistory.myScore}/${customPracticeExamHistory.total}`}
                        </a>
                      ) : (
                        <p>-</p>
                      )}
                    </Col>
                    <Col xs={3} className="text-center p-0">
                      {customPracticeExamHistory?.resolved &&
                      customPracticeExamHistory?.total ? (
                        <div title="Retake exam result">
                          <a
                            onClick={() =>
                              this.reviewClick(
                                customPracticeExamHistory.id,
                                true,
                                true,
                              )
                            }
                            className="linkResult"
                          >
                            {`${customPracticeExamHistory.lastScore}/${customPracticeExamHistory.total}`}
                          </a>
                        </div>
                      ) : (
                        <p>-</p>
                      )}
                    </Col>
                    <Col xs={3} className="text-center p-0">
                      {customPracticeExamHistory?.resolved &&
                      customPracticeExamHistory?.total ? (
                        <p className="my-auto">{`${customPracticeExamHistory.average}/${customPracticeExamHistory.total}`}</p>
                      ) : (
                        <p>-</p>
                      )}
                    </Col>
                    <Col xs={3} className="text-center p-0">
                      {customPracticeExamHistory?.resolved ? (
                        <p className="my-auto">{`${customPracticeExamHistory.pts}pts`}</p>
                      ) : (
                        <p className="my-auto">-</p>
                      )}
                    </Col>
                  </Desktop>

                  <Mobile>
                    {selectOption === 'FIRST SCORE' && (
                      <Col xs={12} className="text-right">
                        {customPracticeExamHistory?.resolved &&
                        customPracticeExamHistory?.total ? (
                          <div>
                            <a
                              onClick={() =>
                                this.reviewClick(
                                  customPracticeExamHistory.id,
                                  false,
                                  true,
                                )
                              }
                              className="linkResult"
                            >
                              {`${customPracticeExamHistory.myScore}/${customPracticeExamHistory.total}`}
                            </a>
                          </div>
                        ) : (
                          <p>-</p>
                        )}
                      </Col>
                    )}
                    {selectOption === 'LAST SCORE' && (
                      <Col xs={12} className="text-right">
                        {customPracticeExamHistory?.resolved &&
                        customPracticeExamHistory?.total ? (
                          <div>
                            <a
                              onClick={() =>
                                this.reviewClick(
                                  customPracticeExamHistory.id,
                                  true,
                                  true,
                                )
                              }
                              className="linkResult"
                            >
                              {`${customPracticeExamHistory.lastScore}/${customPracticeExamHistory.total}`}
                            </a>
                          </div>
                        ) : (
                          <p>-</p>
                        )}
                      </Col>
                    )}
                    {selectOption === 'AVERAGE' && (
                      <Col xs={12} className="text-right">
                        {customPracticeExamHistory?.resolved &&
                        customPracticeExamHistory?.total ? (
                          <p className="my-auto">{`${customPracticeExamHistory.average}/${customPracticeExamHistory.total}`}</p>
                        ) : (
                          <p>-</p>
                        )}
                      </Col>
                    )}
                    {selectOption === 'POINTS' && (
                      <Col xs={12} className="text-right">
                        {customPracticeExamHistory?.resolved ? (
                          <p className="my-auto">{`${customPracticeExamHistory.pts}pts`}</p>
                        ) : (
                          <p className="my-auto">-</p>
                        )}
                      </Col>
                    )}
                  </Mobile>
                </Col>
                {customPracticeExamStatus?.has24HoursPassed === false && (
                  <Col xs={12} md={7}>
                    <small className="bonus-text-xs font-italic">
                      {' '}
                      You can generate a new custom practice exam 24 hours after
                      completing your last one.
                    </small>
                  </Col>
                )}
              </Row>
            </>
          )}
        {this.state.openRegenerateModal && (
          <ModalBase
            isOpen={this.state.openRegenerateModal}
            toggle={() => this.setState({ openRegenerateModal: false })}
            header="REGENERATE CUSTOM PRACTICE EXAM"
            body="This will create a new custom exam with the same chapter selection as the previous custom exam. Do you want to continue?"
            footer={
              <>
                <button
                  className="modal-base-btn secondary"
                  onClick={() => this.setState({ openRegenerateModal: false })}
                >
                  Cancel
                </button>
                <button
                  className="modal-base-btn primary"
                  onClick={this.handleRegenerate}
                  disabled={customPracticeExamLoading}
                >
                  {customPracticeExamLoading ? 'Generating...' : 'Regenerate'}
                </button>
              </>
            }
          />
        )}
        {this.state.openSettingsChangedModal && (
          <ModalBase
            isOpen={this.state.openSettingsChangedModal}
            toggle={() => this.setState({ openSettingsChangedModal: false })}
            header="REGENERATION NOT AVAILABLE"
            body="The exam settings have changed since your last custom exam was created. Please create a new custom exam to continue."
            footer={
              <button
                className="modal-base-btn primary"
                onClick={() =>
                  this.setState({ openSettingsChangedModal: false })
                }
              >
                OK
              </button>
            }
          />
        )}
      </div>
    );
  }
}
export default Cycle;
